import * as React from 'react';
import * as uniqid from 'uniqid';

interface ICheckBoxProps {
  label: string;
  onChange: (e: any) => void;
  fieldName?: string;
  errorMessage?: string;
  value?: any;
  readOnly?: boolean;
  checked?: boolean;
}

export default (props: ICheckBoxProps) => {
  const className = 'checkbox';
  const Id = uniqid('checkbox-');
  const type = null; // hack
  const { fieldName, onChange, label, checked, readOnly, errorMessage, value } = props;

  return (
    <div key={props.fieldName}>
      <div className={`${className}${type ? ' ' + className + '--' + type : ''}${readOnly ? ' disabled' : ''}`}>
        <label className="checkbox__label" htmlFor={Id}>
          <span dangerouslySetInnerHTML={{ __html: label }} />
          <input
            className="checkbox__input"
            id={Id}
            name={fieldName}
            type="checkbox"
            readOnly={readOnly}
            checked={checked != undefined ? checked : false}
            onChange={(e: any) => readOnly !== true && onChange(e)}
          />
          <div className={`checkbox__checkmark${readOnly ? ' disabled' : ''}`} />
        </label>
      </div>

      {props.errorMessage && 
        <p className={'form__error form__error--static'}>{props.errorMessage}</p>}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/FormGenerator/Form/components/CheckBox.tsx